window['ThemeSection_Product'] = ({
  product,
  variant,
  featuredMediaID,
  template,
  thumbnailsPosition,
  showThumbnailsOnMobile,
}) => {
  return {
    productRoot: null,
    product: product,
    current_variant: variant,
    featured_media_id: featuredMediaID,
    current_media_id: featuredMediaID,
    loading: false,
    quantity: '1',
    options: [],
    optionHandles: [],
    storeAvailability: null,
    addedToCart: false,
    stickyAddToCartShown: false,
    template,
    thumbnailsPosition,
    showThumbnailsOnMobile,
    hasGiftCardRecipientForm: false,
    cartAddErrorMessage: null,
    get addToCartText() {
      if (this.current_variant) {
        if (this.loading) {
          return window.theme.strings.loading;
        }
        if (!this.loading && this.current_variant.available) {
          if (this.template === 'product.preorder') {
            return window.theme.strings.preOrder;
          } else {
            return window.theme.strings.addToCart;
          }
        }
        if (!this.loading && !this.current_variant.available) {
          return window.theme.strings.soldOut;
        }
      } else {
        return window.theme.strings.unavailable;
      }
    },
    get currentVariantId() {
      if (this.current_variant) {
        return this.current_variant.id;
      } else {
        return null;
      }
    },
    get currentVariantAvailabilityClosestLocation() {
      // this is on a lag to the actual current variant so that we can display an intermediary state while the fetch request is happening
      if (!Alpine.store('availability')) return null;

      const id = this.currentVariantId;
      const storeData = Alpine.store('availability').availability[id];
      if (storeData) {
        return storeData.closest_location;
      } else {
        return null;
      }
    },
    get currentVariantAvailable() {
      if (this.current_variant) {
        return this.current_variant.available;
      } else {
        return null;
      }
    },
    get currentVariantTitle() {
      if (this.current_variant && this.current_variant.title) {
        if (!this.current_variant.title.includes('Default')) {
          return this.current_variant.title;
        }
      }
      return '';
    },
    get current_price() {
      const selectedSellingPlan = document.querySelector(".skio-group-container--selected");
      const isOneTime = selectedSellingPlan?.querySelector('input[skio-one-time]') ? true : false;
      const price = isOneTime || this.current_variant.selling_plan_allocations.length == 0 ? this.current_variant.price : this.current_variant.selling_plan_allocations[0].price;

      return price;
    },
    get isUsingSlideshowToDisplayMedia() {
      const splideEl = this.productRoot.querySelector('.splide--product');

      if (window.Splide && this.productRoot && splideEl) {
        if (
          window.slideshows &&
          window.slideshows[`${splideEl.id}`] &&
          !window.slideshows[`${splideEl.id}`].state.is(
            window.Splide.STATES.DESTROYED
          )
        ) {
          return true;
        }
      }

      return false;
    },
    formatMoney(price) {
      return formatMoney(price, theme.moneyFormat);
    },
    init() {
      // Set a product root for nested components
      // to use instead of $root (which refers to their root)
      this.productRoot = this.$root;

      if (this.$root.querySelector('[x-data="Theme_GiftCardRecipient"]')) {
        this.hasGiftCardRecipientForm = true;
      }

      if (this.$refs.productForm) {
        // Vérifier si un listener est déjà attaché pour éviter la double soumission
        if (!this.$refs.productForm.hasAttribute('data-listener-attached')) {
          this.$refs.productForm.addEventListener(
            'submit',
            this.submitForm.bind(this)
          );
          // Marquer le formulaire comme ayant déjà un listener attaché
          this.$refs.productForm.setAttribute('data-listener-attached', 'true');
        }
      }

      this.getOptions();
      this.getAddToCartButtonHeight();

      this.$watch('current_media_id', (value, oldValue) => {
        if (showThumbnailsOnMobile) {
          this.$root.dispatchEvent(
            new CustomEvent('shapes:product:mediachange', {
              bubbles: true,
              detail: {
                media_id: this.current_media_id,
                slideshow_id:
                  this.productRoot.querySelector('.splide--product')?.id,
              },
            })
          );
        }
        if (this.isUsingSlideshowToDisplayMedia) return;
        this.$root
          .querySelector(`[data-product-single-media-wrapper="${oldValue}"]`)
          .dispatchEvent(new CustomEvent('mediaHidden'));
        this.$root
          .querySelector(`[data-product-single-media-wrapper="${value}"]`)
          .dispatchEvent(new CustomEvent('mediaVisible'));
      });

      this.updateStoreAvailability(this.current_variant);
    },
    getAddToCartButtonHeight() {
      window.onload = function () {
        const add_to_cart_button = document.querySelector('.add-to-cart-btn');
        if (!add_to_cart_button) return;
        const height = document.querySelector('.add-to-cart-btn').offsetHeight;
        document.documentElement.style.setProperty(
          '--payment-button-height',
          `${height}px`
        );
      };
    },
    updateStoreAvailability(variant) {
      if (!this.$refs.storeAvailabilityContainer) return;
      this.storeAvailability =
        this.storeAvailability ||
        new StoreAvailability(this.$refs.storeAvailabilityContainer);

      if (this.storeAvailability && variant) {
        this.storeAvailability.fetchContent(variant);
      }
    },
    optionChange() {
      this.getOptions();

      const matchedVariant = ShopifyProduct.getVariantFromOptionArray(
        this.product,
        this.options
      );

      this.current_variant = matchedVariant;

      if (this.current_variant) {
        variantLiveRegion(this.current_variant);
        this.updateStoreAvailability(this.current_variant);

        if (this.current_variant.featured_media) {
          this.current_media_id = this.current_variant.featured_media.id;
        }
        const url = ShopifyProductForm.getUrlWithVariant(
          window.location.href,
          this.current_variant.id
        );

        window.history.replaceState({ path: url }, '', url);
        this.$refs.singleVariantSelector.dispatchEvent(
          new Event('change', { bubbles: true })
        );
        this.$root.dispatchEvent(
          new CustomEvent('shapes:product:variantchange', {
            bubbles: true,
            detail: { variant: this.current_variant },
          })
        );
      }
    },
    getOptions() {
      this.options = [];
      this.optionHandles = [];

      let selectors = this.$root.querySelectorAll(
        '[data-single-option-selector]'
      );

      selectors.forEach((selector) => {
        if (selector.nodeName === 'SELECT') {
          const value = selector.value;
          this.options.push(value);
          this.optionHandles.push(
            selector.options[selector.selectedIndex].dataset.handle
          );
        } else {
          if (selector.checked) {
            console;
            const value = selector.value;
            this.options.push(value);
            this.optionHandles.push(selector.dataset.handle);
          }
        }
      });
    },
    changeMedia(direction) {
      this.$root.dispatchEvent(
        new CustomEvent('shapes:product:arrow-change', {
          bubbles: true,
          detail: { direction: direction },
        })
      );
      if (this.thumbnailsPosition == 'under') {
        const currentThumbnail = this.$root.querySelector(
          '.product-thumbnail-list-item--active'
        );
        const nextElement =
          direction == 'prev'
            ? currentThumbnail.previousElementSibling
            : currentThumbnail.nextElementSibling;
        if (nextElement !== null) {
          nextElement.querySelector('.media-thumbnail').click();
        }
      }
    },

    async submitForm(evt) {
      evt.preventDefault();
      
      // Empêcher les soumissions multiples
      if (this.loading) return;
      
      this.loading = true;
      this.addedToCart = false;

      liveRegion(window.theme.strings.loading);

      const formData = new FormData(this.$refs.productForm);
      const formId = this.$refs.productForm.getAttribute('id');

      const product_id = this.$refs.productForm.getAttribute('data-product-id');
      const cartData = window.liquidAjaxCart.cart;
      const item_in_cart = cartData.items.find((item) => item.product_id == product_id);
      const quantity = item_in_cart ? item_in_cart.quantity : 0;

      if (Shopify.country == 'CA' && quantity + 1 > 3 && product_id == "8872545026340") {
        this.loading = false;
        this.cartAddErrorMessage = "You can only purchase up to 3 units of this product.";
        this.addedToCart = false;

        document.body.dispatchEvent(
          new CustomEvent('shapes:cart:adderror', {
            detail: {
              source: 'product-form',
              sourceId: formId,
              variantId: formData.get('id')
            },
          })
        );

        const stickyAddTocartButton = document.querySelector(".elkad-js-subscription-only-button.elkad-js-button--loading");
        const elkadOnlySubscription = this.$refs.productForm.closest(".elkad-only-subscription");

        if (stickyAddTocartButton && elkadOnlySubscription) {
          stickyAddTocartButton.classList.remove("elkad-js-button--loading");
          elkadOnlySubscription.scrollIntoView({ behavior: "smooth" });
        }
        return;
      };

      const config = fetchConfigDefaults('javascript');

      config.body = formData;

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      
      const callback = (data) => {
        this.loading = false;
        this.addedToCart = true;

        if (data.status) {
          this.loading = false;

          const errors = data.errors || data.description;
          const message = data.description || data.message;

          // Gift card recipient form errors are handled in gift-card-recipient.js
          if (!this.hasGiftCardRecipientForm) {
            this.cartAddErrorMessage =
              message || window.theme.strings.cartError;
          }

          document.body.dispatchEvent(
            new CustomEvent('shapes:cart:adderror', {
              detail: {
                source: 'product-form',
                sourceId: formId,
                variantId: formData.get('id'),
                errors,
                message,
              },
            })
          );
          
          return;
        }

        this.loading = false;
        this.cartAddErrorMessage = null;
        this.addedToCart = true;

        if (!document.querySelector('[data-show-on-add="true"]')) {
          if (this.$refs.added) this.$nextTick(() => this.$refs.added.focus());
        }

        const idInString = dataJson.id.toString();
        
        if (idInString.startsWith('47461872173348')) {
          Alpine.store('modals').open('cart');
        }
      };

      const convertFormDataToJson = (formData) => {
        let result = {};
    
        formData.forEach((value, key) => {
            let match = key.match(/^(.+?)\[(.+?)\]$/);
            if (match) {
                let mainKey = match[1];
                let subKey = match[2];
    
                if (!result[mainKey]) {
                    result[mainKey] = {};
                }
                result[mainKey][subKey] = isNaN(value) ? value : Number(value);
            } else {
                result[key] = isNaN(value) ? value : Number(value);
            }
        });
    
        return result;
      };

      // transform the body of the form into a json object
      const dataJson = convertFormDataToJson(formData);

      window.liquidAjaxCart.add(dataJson, {lastCallback: (requestState) => {callback(requestState)}});
    },
    openZoom(id) {
      const imageZoomDataEl = this.productRoot.querySelector(
        '[data-photoswipe-images]'
      );

      if (!imageZoomDataEl) return;

      const imageZoomData = JSON.parse(imageZoomDataEl.innerHTML);

      const imageMediaIDsArray = Object.keys(imageZoomData);

      const index = imageMediaIDsArray.indexOf(id);

      this.$refs.photoSwipeComponent.dispatchEvent(
        new CustomEvent('shapes:photoswipe:open', {
          detail: {
            index: index,
          },
        })
      );
    },
  };
};

window['productThumbnails'] = () => {
  return {
    firstVisible: true,
    lastVisible: false,
    mounted() {
      const firstThumbnail = this.$refs.firstThumbnail;
      const lastThumbnail = this.$refs.lastThumbnail;
      const options = {
        root: this.$root.querySelector('.splide__track'),
        rootMargin: '0px',
        threshold: 1.0,
      };
      const firstThumbnailObserver = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.firstVisible = true;
          } else {
            this.firstVisible = false;
          }
        },
        options
      );
      const lastThumbnailObserver = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.lastVisible = true;
          } else {
            this.lastVisible = false;
          }
        },
        options
      );
      firstThumbnailObserver.observe(firstThumbnail);
      lastThumbnailObserver.observe(lastThumbnail);
    },
  };
};

const popinTogglers = document.querySelectorAll(".elkad-btn-popin, .elkad-popin__close, .elkad-overlay");
const popin = document.querySelector('.elkad-popin');

const togglePopin = () => {
  popin.classList.toggle('elkad-popin--opened');
  document.querySelector("body").classList.toggle("elkad-overlay-active");
}

if (popin) {
  popinTogglers.forEach(toggler => {
    toggler.addEventListener('click', e => {
      e.preventDefault();

      togglePopin();
    });
  });
}
